import { useState } from "react";
import { MainLayout } from "../../index.style";
import {
  ContactInfo,
  ContactWrapper,
  FormWrapper,
} from "../../styles/pages/contact.style";

import { Button } from "../../styles/global/main.style";
import emailjs from "@emailjs/browser";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
const Quote = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  emailjs.init("hnmTkJcIe7zeb7MMi");

  const onSubmit = (data) => {
    setIsSubmitting(true);

    const templateParams = {
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      phoneNumber: data.phoneNumber,
      pickupZip: data.pickupZip,
      deliveryZip: data.deliveryZip,
      truckType: data.truckType,
      subject: "Quote Request",
      quoteDetails: `Pickup Zip: ${data.pickupZip}\nDelivery Zip: ${data.deliveryZip}\nTruck Type: ${data.truckType}`,
    };

    emailjs
      .send("service_zou6btr", "template_qk92avz", templateParams)
      .then(
        (response) => {
          navigate("/success");
          reset(); // Reset form after successful submission
        },
        (error) => {
          console.log("FAILED...", error);
          alert("Failed to send message. Please try again.");
        },
      )
      .finally(() => {
        setIsSubmitting(false);
      });
  };
  return (
    <MainLayout>
      <ContactWrapper>
        <div className="text">
          <div className="contact-header">
            <span id="header">Request a Quote</span>
            <span id="sub-header">
              Get a quote for your transportation needs. Provide us with your
              pickup and delivery locations, truck type, and contact
              information, and our team will reach out to you with pricing and
              availability.
            </span>
          </div>
          <div className="contact-info">
            <ContactInfo>
              <img src="/images/mail-ico.svg" alt="Email" />
              service@reliabletruckinggroup.com
            </ContactInfo>
            <ContactInfo>
              <img src="/images/phone-ico.svg" alt="Phone" />
              +1 (833) 425-5643
            </ContactInfo>
          </div>
          <div className="hours-info">
            <span className="form-header">Hours</span>
            <span id="sub-header">
              We are available to assist you with your maintenance needs anytime
              and anywhere. That includes after hours, weekends, and holidays.
            </span>
          </div>
        </div>
        <FormWrapper>
          <span className="form-header">Request Your Quote</span>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="name">
              <label htmlFor="firstName">
                First Name
                <input
                  id="firstName"
                  className={`input ${errors.firstName ? "error" : ""}`}
                  placeholder="John"
                  {...register("firstName", {
                    required: "First name is required",
                  })}
                />
                {errors.firstName && (
                  <span className="error-message">
                    {errors.firstName.message}
                  </span>
                )}
              </label>
              <label htmlFor="lastName">
                Last Name
                <input
                  id="lastName"
                  className={`input ${errors.lastName ? "error" : ""}`}
                  placeholder="Doe"
                  {...register("lastName", {
                    required: "Last name is required",
                  })}
                />
                {errors.lastName && (
                  <span className="error-message">
                    {errors.lastName.message}
                  </span>
                )}
              </label>
            </div>
            <label htmlFor="email">
              Email Address
              <input
                id="email"
                type="email"
                className={`input ${errors.email ? "error" : ""}`}
                placeholder="john.doe@example.com"
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /\S+@\S+\.\S+/,
                    message: "Invalid email address",
                  },
                })}
              />
              {errors.email && (
                <span className="error-message">{errors.email.message}</span>
              )}
            </label>
            <label htmlFor="phoneNumber">
              Phone Number
              <input
                id="phoneNumber"
                type="tel"
                className={`input ${errors.phoneNumber ? "error" : ""}`}
                placeholder="+1 (123) 456-7891"
                {...register("phoneNumber", {
                  required: "Phone number is required",
                })}
              />
              {errors.phoneNumber && (
                <span className="error-message">
                  {errors.phoneNumber.message}
                </span>
              )}
            </label>
            <label htmlFor="pickupZip">
              Pickup Zip Code
              <input
                id="pickupZip"
                className={`input ${errors.pickupZip ? "error" : ""}`}
                placeholder="12345"
                {...register("pickupZip", {
                  required: "Pickup zip code is required",
                })}
              />
              {errors.pickupZip && (
                <span className="error-message">
                  {errors.pickupZip.message}
                </span>
              )}
            </label>
            <label htmlFor="deliveryZip">
              Delivery Zip Code
              <input
                id="deliveryZip"
                className={`input ${errors.deliveryZip ? "error" : ""}`}
                placeholder="54321"
                {...register("deliveryZip", {
                  required: "Delivery zip code is required",
                })}
              />
              {errors.deliveryZip && (
                <span className="error-message">
                  {errors.deliveryZip.message}
                </span>
              )}
            </label>
            <label htmlFor="truckType">
              Type of Truck Needed
              <input
                id="truckType"
                className={`input ${errors.truckType ? "error" : ""}`}
                placeholder="e.g. Flatbed, Dry Van, Refrigerated"
                {...register("truckType", {
                  required: "Truck type is required",
                })}
              />
              {errors.truckType && (
                <span className="error-message">
                  {errors.truckType.message}
                </span>
              )}
            </label>
            <Button type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Sending..." : "Submit Quote Request"}
            </Button>
          </form>
        </FormWrapper>
      </ContactWrapper>
    </MainLayout>
  );
};

export default Quote;
